export default {
  sidebarWidth: '72px',
  sidebarHeight: '100svh',
  settingsMenuWidth: '260px',
  headerheight: '64px',
  mobileDawerWidth: '250px',
};
